import * as z from "zod/v4";

export const handleRedoSuppliesCheckoutCompleted = {
  name: "handleRedoSuppliesCheckoutCompleted" as const,
  input: z.object({ checkoutSessionId: z.string() }),
  output: z.object({ orderId: z.string(), orderName: z.string() }),
};
